<template>
  <div>
    <div
      class="style1-wap"
      :class="{
        must: fieldObj.required == 1,
        err: fieldObj.dirty && fieldObj.invalid
      }"
    >
      <div class="u-label">
        {{ fieldObj.displayName }}
      </div>
      <div class="m-input">
        <!-- <a-date-picker
                    :show-time="fieldObj.showTime"
                    :format="fieldObj.format"
                    :value-format="fieldObj.format"
                    :placeholder="'请选择'+fieldObj.displayName"
                    v-model="timeValue"
                    @change="handleChange"
                /> -->
        <van-cell-group>
          <van-field
            v-if="!fieldObj.disabled"
            :readonly="true"
            v-model="fieldDate"
            @click="isShowDatePicker = !isShowDatePicker"
            :placeholder="'请选择' + fieldObj.displayName"
            right-icon="calendar-o"
          />
          <van-field
            v-if="fieldObj.disabled"
            disabled
            v-model="fieldDate"
            :placeholder="'请选择' + fieldObj.displayName"
            right-icon="calendar-o"
          />
        </van-cell-group>
        <van-datetime-picker
          :class="{
            'datetime-picker-year':
              field.dateLimitType === 'YEAR' || field.accuracy === 'YEAR'
          }"
          v-show="isShowDatePicker"
          :title="titleTxt"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          v-model="timeValue"
          :type="dateType"
          @change="handleChange"
          @cancel="cancel"
          @confirm="confirm"
        />
      </div>
      <div class="u-reg-err-tips" v-show="fieldObj.dirty && fieldObj.invalid">
        请选择日期
      </div>
    </div>
  </div>
</template>
<script>
import datePickerWapMixin from "../../field/new-fields/date-picker-wap";
export default {
  name: "sk-date-picker-wap",
  mixins: [datePickerWapMixin]
};
</script>
<style lang=""></style>
